"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Front = _interopRequireDefault(require("Layouts/Front"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const BecomeVolonteer = () => {
  return /*#__PURE__*/_react.default.createElement(_Front.default, {
    page_title: "Devenez b\xE9n\xE9vole"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "o-content donate-page"
  }, /*#__PURE__*/_react.default.createElement("h1", null, "Devenez b\xE9n\xE9vole!"), /*#__PURE__*/_react.default.createElement("p", null, "Il y a tant \xE0 faire \u2026. Et nous sommes trop peu nombreux\u2026. Venez nous rejoindre, votre aide nous sera pr\xE9cieuse."), /*#__PURE__*/_react.default.createElement("h4", null, "Pour poser votre candidature : "), /*#__PURE__*/_react.default.createElement("a", {
    href: "mailto: alemploiparis@gmail.com"
  }, " alemploiparis@gmail.com")));
};
var _default = exports.default = BecomeVolonteer;
